<div class="mt-8 hidden lg:hidden">
</div>
<div class="overflow-x-auto">
  <table class="w-full text-left border-collapse">
    <thead class="bg-gray-100">
    <tr>
      <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Order #</th>
      <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Date Purchased</th>
      <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Status</th>
      <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Total</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let order of orders" class="hover:bg-gold hover:bg-opacity-10 transition duration-300">
      <td class="px-6 py-4 border-b border-gray-200">
        <a class="text-gold hover:text-gold-dark font-medium transition duration-300" href="#" (click)="openOrderDetails(order)">#{{order.number}}</a>
      </td>
      <td class="px-6 py-4 border-b border-gray-200">{{order.date | date:'mediumDate'}}</td>
      <td class="px-6 py-4 border-b border-gray-200">
        <span class="text-blue-600 font-medium">{{order.status || 'In Progress'}}</span>
      </td>
      <td class="px-6 py-4 border-b border-gray-200">
        <span class="font-medium text-gold">{{order.total *13 | currency:'MAD'}}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<hr class="border-t-2 border-gray-200 my-6">
